import { useState } from "react";
import axios from "axios";
import { AdminLogin } from "../components/admin/AdminLogin";
import { FicheList } from "../components/admin/FicheList";
import { Footer } from "../components/fiche/Chrome";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "ombodhi-admin";

export default function Admin() {
  const [password, setPassword] = useState(() => sessionStorage.getItem(KEY) || "");
  const [fiches, setFiches] = useState(null);
  const [notice, setNotice] = useState("");

  const load = async (pwd) => {
    setNotice("");
    try {
      const { data } = await axios.get(`${API}/admin/fiches`, { headers: { "X-Admin-Password": pwd } });
      sessionStorage.setItem(KEY, pwd);
      setPassword(pwd);
      setFiches(data);
    } catch (e) {
      sessionStorage.removeItem(KEY);
      setFiches(null);
      setNotice(e.response?.status === 401 ? "Vérifiez le mot de passe et réessayez." : "Le chargement demande un nouvel essai.");
    }
  };

  const logout = () => {
    sessionStorage.removeItem(KEY);
    setPassword("");
    setFiches(null);
  };

  return (
    <div className="ob-page">
      <main className="ob-wrap ob-wrap-wide" data-testid="admin-page">
        <header className="ob-header">
          <p className="ob-brand">OMBODHI</p>
          <h1 className="ob-title">Fiches reçues</h1>
          <p className="ob-subtitle">Chaque fiche, prête à relire avant l'appel.</p>
          <div className="ob-rule" />
        </header>
        {fiches ? (
          <FicheList fiches={fiches} password={password} api={API} onRefresh={() => load(password)} onLogout={logout} />
        ) : (
          <AdminLogin initial={password} onSubmit={load} notice={notice} />
        )}
        <Footer />
      </main>
    </div>
  );
}
